import heroImg from "../images/hero.jpg";

export default function Hero({ data }) {
  return (
    <section id="hero" style={{ padding: 0 }}>
      <div className="hero">
        <div className="hero-left">
          <p className="hero-tag">{data.tag}</p>
          <h1 className="hero-title">{data.title}</h1>
          <div className="hero-scroll">
            <div className="hero-scroll-line" />
            {data.scrollLabel}
          </div>
        </div>
        <div className="hero-right">
          <div className="hero-image-container">
            <div
              className="hero-image-bg"
              style={{ backgroundImage: `url(${heroImg})` }}
            />
            <div className="hero-image-overlay" />
            <div className="hero-number">I</div>
          </div>
        </div>
      </div>
    </section>
  );
}
